import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CART_NORMALIZER } from '@spartacus/cart/base/root'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'
import { EbCart } from '../../../cart/interface/eb-cart.interface'

@Injectable({ providedIn: 'root' })
export class EbCompleteDeliveryAdapter {
  constructor(
    private readonly http: HttpClient,
    private readonly occEndpoints: OccEndpointsService,
    private readonly converterService: ConverterService
  ) {}

  setDeliveryModeType(
    cartId: string,
    userId: string,
    completedDelivery: boolean
  ): Observable<EbCart> {
    const url = this.occEndpoints.buildUrl('setCompleteDelivery', {
      urlParams: {
        userId,
        cartId,
        completedDelivery
      }
    })
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http
      .put(url, { headers })
      .pipe(this.converterService.pipeable(CART_NORMALIZER)) as Observable<EbCart>
  }
}
